import React from 'react'
import PropTypes from 'prop-types'

import Loader from '../../atoms/Loader'
import FundDividendItem from './FundDividendItem'

import useLoading from '../../hook/useLoading'

import './style.scss'

const FundDividendStandalone = ({ fundDividendStandaloneTable, deferLoading }) => {
  const loading = useLoading(
    [
      fundDividendStandaloneTable.length,
      fundDividendStandaloneTable[0].fundName,
      fundDividendStandaloneTable[fundDividendStandaloneTable.length - 1].fundName
    ],
    500,
    deferLoading
  )

  return (
    <>
      {loading ? (
        /* istanbul ignore next */ <Loader />
      ) : (
        fundDividendStandaloneTable.map((DividendStandaloneItem, idx) => {
          const { fundId, fundName, description, tableData } = DividendStandaloneItem
          const props = { fundName, description, tableData }
          return <FundDividendItem {...props} index={idx + 1} key={fundId} deferLoading={deferLoading} />
        })
      )}
    </>
  )
}

FundDividendStandalone.propTypes = {
  fundDividendStandaloneTable: PropTypes.array.isRequired,
  deferLoading: PropTypes.bool
}

FundDividendStandalone.defaultProps = {
  deferLoading: true
}

export default FundDividendStandalone
